export enum TransactionType {
  Lapsed = 14,
}
